import { ODataObject } from '../../interfaces/odata-model.interface';
import { CompositeModel } from './composite.model';
import { NumberModel, JsonNumberModel } from '../primitive/number.model';
import { TextModel, JsonTextModel } from '../primitive/text.model';

export class CodeModel extends CompositeModel {
    public pos: NumberModel;
    public codeType: TextModel;
    public qkatart: TextModel;
    public codeGroup: TextModel;
    public codeName: TextModel;
    public codeDesc: TextModel;
    public constructor(
        pos: number,
        codeType: string,
        qkatart: string,
        codeGroup: string,
        codeName: string,
        codeDesc: string,
    ) {
        super('CodeModel');

        this.pos = <NumberModel>this.set(new NumberModel('Pos', pos));
        this.codeType = <TextModel>this.set(new TextModel('CodeType', codeType));
        this.qkatart = <TextModel>this.set(new TextModel('Qkatart', qkatart));
        this.codeGroup = <TextModel>this.set(new TextModel('CauseCodeGroup', codeGroup));
        this.codeName = <TextModel>this.set(new TextModel('CauseCode', codeName));
        this.codeDesc = <TextModel>this.set(new TextModel('CodeDesc', codeDesc));
    }

    public static fromOData(data: ODataCodeModel): CodeModel {
        return new CodeModel(data.Counter, data.CodeType, data.Qkatart, data.CodeGroup, data.CodeName, data.CodeDesc);
    }
}

export class CodeModelFromJson extends CodeModel {
    public constructor(data: JsonCodeModel) {
        super(
            data.pos.value,
            data.codeType.value,
            data.qkatart.value,
            data.codeGroup.value,
            data.codeName.value,
            data.codeDesc.value,
        );
    }
}

export interface ODataCodeModel extends ODataObject {
    Counter: number;
    CodeType: string;
    Qkatart: string;
    CodeGroup: string;
    CodeName: string;
    CodeDesc: string;
    __metadata: {
        uri: string;
        id: string;
        type: 'HC_SM_NGM_58_SRV.Code';
    };
}

export interface JsonCodeModel {
    pos: JsonNumberModel;
    codeType: JsonTextModel;
    qkatart: JsonTextModel;
    codeGroup: JsonTextModel;
    codeName: JsonTextModel;
    codeDesc: JsonTextModel;
}
